module.exports = __webpack_public_path__ + "img/P66-en.63a7e56d.png";